import React, { useState, useEffect } from "react";
import styles from "./AnalyticsView.module.css";
import { useFont } from "../../contexts/FontContext/FontContext";
import SelectDateRange from "./SelectDateRange";
import ChartData from "./ChartData";
import { delay } from "../utils/common";

const AnalyticsView = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const [accountAge, setAccountAge] = useState(null);
    const [shippingLabelData, setShippingLabelData] = useState(null);
    const [businessName, setBusinesName] = useState(null);
    const [isCalendarVisible, setIsCalendarVisible] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [titleState, setTitleState] = useState(""); // Initialize with an empty string
    const [totalLabelRevenue, setTotalLabelRevenue] = useState(0);
    const fontSchemes = useFont();
    const fontFamilyOne = fontSchemes.scheme_one;
    const token = localStorage.getItem("authToken");
    const [startDate, setStartDate] = useState(() => {
        const oneMonthAgo = new Date();
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
        return oneMonthAgo;
    });
    const [endDate, setEndDate] = useState(new Date());
    const filteredData = shippingLabelData?.filter(item => {
        const createdAt = new Date(item.created_at);
        return createdAt >= startDate && createdAt <= endDate;
    });

    useEffect(() => {
        const fetchShippingLabelData = async () => {
            const userId = localStorage.getItem("user");
            try {
                // Fetch data from backend API
                const response = await fetch(`${apiUrl}/api/get_shipping_label_data/?user_id=${userId}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                });
                if (!response.ok) { alert("no data has been recorded yet!"); }
                const data = await response.json();
                setAccountAge(data.account_age);
                setBusinesName(data.business_name);
                setShippingLabelData(data.shipments);
            } catch (err) { setError(err.message); } 
            await delay(500);
            setLoading(false); 
        };
        fetchShippingLabelData();
    }, []);

    // Update titleState whenever businessName changes
    useEffect(() => {
        if (businessName) { setTitleState(`${businessName} revenue breakdown`); }
    }, [businessName]);

    useEffect(() => {
        if (shippingLabelData) {
            const total = shippingLabelData.reduce((acc, curr) => acc + curr.label_purchase_price, 0); 
            setTotalLabelRevenue(total.toFixed(2));
        }
    }, [shippingLabelData]);

    return (
        <div className={`${styles.analytics_container} ${fontFamilyOne}`}>
            <p className={`${styles.analytics_title_text} fade_in`}>{titleState}</p>
            {error && (<p className={`error_message ${styles.calendar_error}`}>{error}</p>)}
            {loading && (<img className={styles.analytics_loader} src={`${process.env.PUBLIC_URL}/images/shipwheel_loader.gif`} />)}
            {!loading && (
                <>
                    <SelectDateRange font={fontFamilyOne} titleState={titleState} setTitleState={setTitleState} businessName={businessName} error={error} setError={setError} isCalendarVisible={isCalendarVisible} setIsCalendarVisible={setIsCalendarVisible} startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} />
                    <ChartData font={fontFamilyOne} data={filteredData} isCalendarVisible={isCalendarVisible} setIsCalendarVisible={setIsCalendarVisible} />
                    {!isCalendarVisible && (
                        <div className={styles.data_summary_box}>
                            <div className={`${styles.summary_item_container} ${styles.summary_item_label}`}>
                                <p className={styles.account_age}>Account age: </p>
                                <p className={styles.label_revenue}>Total revenue: </p>
                            </div>
                            <div className={`${styles.summary_item_container} ${styles.summary_item_value}`}>
                                <p className={styles.account_age}>{accountAge}</p>
                                <p className={`${styles.label_revenue} ${styles.revenue_value}`}>${totalLabelRevenue}</p>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default AnalyticsView;